import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import { LedgerTransactionService } from '../../services/ledger-transaction.service';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid as exportDataGridToExcel } from 'devextreme/excel_exporter';
import { exportDataGrid as exportDataGridToPDF } from "devextreme/pdf_exporter";
import { DxDataGridComponent, DxDataGridTypes } from 'devextreme-angular/ui/data-grid'
import { cardSummayDetail } from '../../components/utils/models/cardsummaydetail';
import { DataServiceService } from '../../services/data-service.service';
import CustomStore from 'devextreme/data/custom_store';
import { jsPDF } from 'jspdf';
import { EnvironmentService } from '../../services/environment.service';
import { DataCardInterface } from '../../components/utils/models/data-card-interface';

@Component({
  selector: 'app-ledger-transaction',
  templateUrl: './ledger-transaction.component.html',
  styleUrl: './ledger-transaction.component.scss',
  providers: [LedgerTransactionService]
})
export class LedgerTransactionComponent implements OnInit {
  isContentScrolled = false;
  cardValues: cardSummayDetail[] = [];
  cardDataValues: DataCardInterface[] = []
  defaultValues: any[] = [
    { titleText: 'Trust', value: 0, type: 'currency', icon: 'heroBanknotes' },
    { titleText: 'Business', value: 0, type: 'currency', icon: 'heroBanknotes' },
    { titleText: 'Disbursement', value: 0, type: 'currency', icon: 'heroBanknotes' },
    { titleText: 'Card', value: 0, type: 'currency', icon: 'heroBanknotes' },
    { titleText: 'Merchants', value: 0, type: 'currency', icon: 'heroBanknotes' }
    
  ];
  ledgerTransactionDataSource: DataSource;
  summary: any;
  totalRecords: number = 0;
  currentPageCount: number = 0;

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent

  constructor(private route: ActivatedRoute, private service: LedgerTransactionService, dataService: DataServiceService, private environmentService: EnvironmentService) {
    this.ledgerTransactionDataSource = dataService.getLedgerTransactionsDataSource();

  }

  scroll({ reachedTop = false }) {
    this.isContentScrolled = !reachedTop;
  }
  ngOnInit(): void {

    this.service.getCardValues()
      .subscribe(
        (data: cardSummayDetail[]) => {
          // TODO: data seems to have changed type here. Fix this
          const elementsNotInDataValues = this.defaultValues.filter(
            item => !data.some(dbresItem => dbresItem['ledgerName'] === item['titleText'])
          );
          
          data.map(d => this.cardDataValues.push({
            titleText: d['ledgerName'],
            value: d['totalAmount'],
            type: 'currency',
            icon: 'heroBanknotes'
          }));

          elementsNotInDataValues
            .map(d =>
              this.cardDataValues.push({
              titleText: d['titleText'],
              value: d['value'],
              type: d['type'],
              icon: d['icon']
              })
            );

        },
        (error: any) => {
          console.error('Error fetching card values', error);
        }
      );

  }

  calculateSummary(data: any[]): any {

    let totalAmount = data?.reduce((sum, item) => sum + item.Amount, 0) ?? 0;
    return { totalAmount: totalAmount };
  }

  customCountFormat(e: any): string {
    return `${e.valueText}`;
  }

  isValidDateUsingParse(dateString: string): boolean {
    const timestamp = Date.parse(dateString);
    return !isNaN(timestamp); // Check if timestamp is valid
  }

  customCurrencyFormat = {
    formatter: (value) => {
      // Define the currency formatter
      const currencyFormatter = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      // Format the value
      let formattedValue = currencyFormatter.format(value);
      return formattedValue;
    }
  };

  isDestructible(filterString: string): boolean {
    // Split the string by commas
    const parts = filterString.split(',');

    // Check if the resulting array has exactly three elements
    if (parts.length === 3 && parts.every(part => part.trim() !== '')) {
      const [field, operator, value] = parts;

      // Optionally validate the field, operator, and value
      if (field && operator && value) {
        return true;
      }
    }
    return false;
  }


  onCellPrepared(e) {
    if (e.rowType === "data") {

      if (e.column.dataField === "Amount" && e.data.Amount < 0) {
        e.cellElement.style.cssText = "color: red;font-weight:bold;text-align:right;";
      }

      if (e.column.dataField === "Wallet" && (e.data.Wallet == null || e.data.Wallet == undefined || e.data.Wallet.length == 0)) {
        e.cellElement.innerText = '-'
      }

    }
  }

  onExporting(e: any) {
    if (e.format === 'xlsx') {
      this.exportToExcel(e);
    } else if (e.format === 'pdf') {
      this.exportToPDF(e);
    }
  }

  exportToExcel(e: DxDataGridTypes.ExportingEvent) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('LedgerTransactions');

    exportDataGridToExcel({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        const now = new Date();
        const TodaysDate = this.formatDate(now)
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `LedgerTransactions_${TodaysDate}.xlsx`);
      });
    });
  }

  async exportToPDF(e: any) {
    const doc = new jsPDF('landscape');
    const pngBase64 = await this.convertPngToBase64('assets/icons/bitventurelogo.png');

    // Get the page width and height
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Define the image width and height
    const imageWidth = 20;  // Adjust width
    const imageHeight = 5;  // Adjust height

    // Define margins
    const marginRight = 10; // Margin from the right edge
    const marginTop = 10;   // Margin from the top edge
    const marginBelow = 20; // Margin below the image

    // Calculate the x and y coordinates for the image
    const x = pageWidth - imageWidth - marginRight;
    const y = marginTop;

    // Add PNG image to PDF
    doc.addImage(pngBase64, 'PNG', x, y, imageWidth, imageHeight);

    // Set the y coordinate for the grid data, starting below the image
    const gridY = y + imageHeight + marginBelow;

    // Export DataGrid to PDF
    await exportDataGridToPDF({
      jsPDFDocument: doc,
      component: e.component,
      margin: { top: gridY, left: 2, right: 2 } // Start the grid data export below the image
    });

    // Save the PDF
    const now = new Date();
    const todaysDate = this.formatDate(now);
    doc.save(`LedgerTransactions_${todaysDate}.pdf`);
    e.cancel = true;
  }

  async convertPngToBase64(pngFilePath: string): Promise<string> {
    const response = await fetch(pngFilePath);
    const blob = await response.blob();
    const reader = new FileReader();
    return new Promise<string>((resolve, reject) => {
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}/${month}/${day}, ${hours}:${minutes}:${seconds}`;
  }

  formatCurrency(value) {
    return `R${value.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  ngAfterViewInit() {
    this.refreshDataGrid();
  }

  refreshDataGrid() {
    this.ledgerTransactionDataSource.load();

  }


  clearAllFilters() {
    this.dataGrid.instance.clearFilter();
    this.dataGrid.instance.clearSelection();
    this.dataGrid.instance.clearSorting();
    this.dataGrid.instance.state(null);
  }
}
